import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import { BuyOptionPropType } from "web/types/buy-option";
import { ProductPropType } from "web/types/product";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import styles from "./color-picker.css";

function Variant(_ref) {
  var _classnames;

  var allSortedBuyOptions = _ref.allSortedBuyOptions,
      buyOptions = _ref.buyOptions,
      current = _ref.current,
      onClick = _ref.onClick,
      product = _ref.product;
  var sortedBuyOptions = allSortedBuyOptions.filter(function (linkId) {
    return product.link_ids.includes(linkId);
  });
  var buyOption = buyOptions[sortedBuyOptions[0]];
  var inStock = buyOption.in_stock;
  var variantClass = classnames(styles.variant, (_classnames = {}, _defineProperty(_classnames, styles.oos, !inStock), _defineProperty(_classnames, styles.current, current === product.product_id), _classnames));
  var useLink = inStock && !onClick;
  var trackOnClick = useClickTracker("color_picker", "clicked", "", useLink);

  function changeColor(event) {
    if (inStock) {
      trackOnClick(event);

      if (onClick) {
        event.preventDefault();
        onClick(product.product_id);
      }
    } else {
      event.preventDefault();
    }
  }

  return React.createElement("li", {
    className: variantClass
  }, React.createElement("a", {
    onClick: changeColor,
    href: product.canonical_url,
    "aria-disabled": !inStock,
    className: classnames(_defineProperty({}, styles.oosLink, !inStock))
  }, React.createElement("img", {
    className: styles.img,
    src: product.images[0].thumbnail_url,
    alt: product.color
  })));
}

Variant.propTypes = {
  allSortedBuyOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  buyOptions: PropTypes.objectOf(BuyOptionPropType).isRequired,
  current: PropTypes.string,
  onClick: PropTypes.func,
  product: ProductPropType.isRequired
};

function ColorPicker(_ref2) {
  var allSortedBuyOptions = _ref2.allSortedBuyOptions,
      buyOptions = _ref2.buyOptions,
      className = _ref2.className,
      current = _ref2.current,
      onClick = _ref2.onClick,
      products = _ref2.products,
      variantLimit = _ref2.variantLimit,
      variants = _ref2.variants;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var variantsToShow = variantLimit;

  if (open) {
    variantsToShow = variants.length;
  }

  return React.createElement("div", {
    className: classnames(className, styles.wrapper)
  }, React.createElement("ul", {
    className: styles.variants
  }, variants.slice(0, variantsToShow).map(function (variant) {
    var product = products[variant];
    return React.createElement(Variant, {
      key: product.product_id,
      allSortedBuyOptions: allSortedBuyOptions,
      buyOptions: buyOptions,
      current: current,
      onClick: onClick,
      product: product
    });
  }), variants.length > variantLimit && React.createElement("li", {
    className: styles.more
  }, React.createElement("button", {
    className: styles.button,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, React.createElement("span", null, open ? gettext("general.see_less") : gettext("general.see_more"))))));
}

ColorPicker.defaultProps = {
  variantLimit: 10
};
ColorPicker.propTypes = {
  allSortedBuyOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  buyOptions: PropTypes.objectOf(BuyOptionPropType).isRequired,
  className: PropTypes.string,
  current: PropTypes.string,
  onClick: PropTypes.func,
  products: PropTypes.objectOf(ProductPropType).isRequired,
  variantLimit: PropTypes.number,
  variants: PropTypes.arrayOf(PropTypes.string).isRequired
};
export default ColorPicker;